export const DejavooTop = {
  isAvailable: async () => ({
    available: false,
    nfc: false,
    platform: 'web'
  }),
  getDeviceSupport: async () => ({ platform: 'web', supported: false, reason: 'web' }),
  getRegistrationStatus: async () => ({
    ready: false,
    parametersDownloaded: false,
    merchantAccepted: false
  }),
  refreshMerchantAcceptanceStatus: async () => ({
    parametersDownloaded: false,
    merchantAccepted: false,
    ready: false
  }),
  checkDeviceConfiguration: async () => ({ checked: false }),
  warmSession: async () => {},
  performSale: async () => ({
    approved: false,
    status: 'unavailable',
    message: 'Tap to Pay is only available in Capacitor Android builds'
  })
}
